module.exports = __webpack_public_path__ + "media/images/apple-touch-icon-152x152-8a2a8cf3e69f61a572688c1afe0e1d3a.png";